import { render, staticRenderFns } from "./substitute-teacher-admin.view.vue?vue&type=template&id=de1a2ec4&scoped=true&"
import script from "./substitute-teacher-admin.view.ts?vue&type=script&lang=ts&"
export * from "./substitute-teacher-admin.view.ts?vue&type=script&lang=ts&"
import style0 from "./substitute-teacher-admin.view.scss?vue&type=style&index=0&id=de1a2ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1a2ec4",
  null
  
)

export default component.exports